import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextField, FormHelperText } from "@mui/material";

const TextArea = ({ name, props }) => {
  return (
    <div>
      <Field
        as={TextField}
        name={name}
        multiline
        rows={5}
        fullWidth
        error={props.errors[name] && props.touched[name]}
        size="small"
        // required
      />
      <FormHelperText sx={{ color: "#d32f2f" }}>
        <ErrorMessage name={name} />
      </FormHelperText>
    </div>
  );
};

export default TextArea;
